import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './status.module.scss';

const Status = ({ options, item }) => {
  const definedOptions = {
    'pending': {
      style: styles.pending,
      name: 'Pending'
    },
    'approve': {
      style: styles.completed,
      name: 'Approved'
    },
    'rejected': {
      styles: styles.rejected,
      name: 'rejected'
    }
  };

  let statusOptions = options || definedOptions;
  return (
    <div className={statusOptions[item?.toLowerCase()]?.style}>
      <FormattedMessage
        id={`list.table.status.${statusOptions[item?.toLowerCase()]?.name}`}
        defaultMessage={statusOptions[item?.toLowerCase()]?.name}
      />
    </div>
  );
};

Status.propTypes = {
  item: PropTypes.number.isRequired
};
export default Status;
